<template>
  <section class="member-signup custom-margin">
    <div class="row">
      <div class="col-xs-12 headline-container">
        <h2 class="headline-lg medium">{{ d.consenttitle }}</h2>
        <label class="consent-toggle" for="consent-to-all">
          <input
            id="consent-to-all"
            type="checkbox"
            v-model="values.consent"
            @change="toggleAllCheckboxes"
          />
          <div class="consent-toggle-box"></div>
          <span class="consent-text">{{ d.consentacceptall }}</span>
        </label>
      </div>
      <div class="col-xs-12 consent-item-container">
        <p>{{ d.consenttext }}</p>
        <div
          class="consent-item"
          v-for="item in consentItems.filter((x) => x.visible)"
          :key="item.id"
        >
          <div>
            <label
              class="checkbox consent-item-checkbox"
              :for="item.id"
              @change="setMasterToggle()"
            >
              <input
                type="checkbox"
                class="check-after-input"
                :id="item.id"
                v-model="item.checked"
              />
              <span class="checklabel">{{ item.label }}</span>
              <span class="checkmark"></span>
            </label>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
      <div class="col-xs-12 consent-rules-link">
        <a :href="d.consentarticlesurl" class="consent-link" target="_blank">{{ d.consentarticles }}</a><br />
        <a :href="d.consentGdprArticlesurl" class="consent-link" target="_blank">{{ d.consentGdprArticles }}</a>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import {} from "@vuelidate/validators";
import { cultureMixin } from "../../util/cultureMixin.js";

export default {
  mixins: [cultureMixin],
  setup() {
    // we use vuelidate for validation
    // https://vuelidate-next.netlify.app/
    return { v$: useVuelidate({ $lazy: true }) };
  },
  data: (instance) => {
    const d = instance.store[instance.store.currentCulture].dictionary;
    const values = instance.store[instance.store.currentCulture].values.personalDetails;
    const product = instance.store[instance.store.currentCulture].values.productDetails;
    const insurance = instance.store[instance.store.currentCulture].values.insuranceDetails;
    
    


    return {
      values: values,
      d: d,
      culture: instance.store.currentCulture,
      product: product,
      insurance: insurance,
      dictionaryData: {},
      isLoading: false,
      error: null,
      consentItems: [],
    };
  },
  beforeUnmount() {
    this.emitter.off('culture-change', this.loadData);
  },
  methods: {
    async loadData(){
      this.getConsentBoxes();
    },
    async getConsentBoxes(){
      const consents = await axios.get(
        `/umbraco/api/signup/GetConsentOptions?culture=${this.GetCulture()}`
      );
      const consentItems = consents.data.map((f) => ({
        id: "consent_" + f.Id,
        label: f.Headline ?? "no headline provided",
        text: f.Text,
        checked: false,
        salerydecuctionconsent: f.salerydecuctionconsent,
        visible: true,
        returninsetconsent: f.returninsetconsent,
      }));
      this.consentItems = consentItems;
      this.renderDynamicCheckbox();
    },
    async renderDynamicCheckbox() {
      this.consentItems.forEach((x) => {
        if (x.salerydecuctionconsent) {
          // SAMTYKKE LØNTRÆK
          x.visible = this.values.payByCompany;
        } else if (x.id == "consent_2") {
          // SAMTYKKE TIL INFO
          x.visible = this.product.unionselected || this.product.unemploymentinsuranceselected;
        } else if (x.id == "consent_3") {
          // SAMTYKKE TIL E-BOKS
          x.visible = this.product.unionselected;
        } else if (x.id == "consent_1001") {
          // UDMELDELSE AF ANDEN FAGFORENING
          x.visible = this.values.unionunsubscribe == "ja" && this.values.unionwhichone.trim().length > 0;
        } else if (x.id == "consent_1002") {
          // FTFa SAMTYKKE
          x.visible = this.product.unemploymentinsuranceselected;
        }
        else if (x.id == "consent_1003") {
          // FORSIKRING
          x.visible = this.insurance.homeInsurance;
        }
      });
    },
    toggleAllCheckboxes() {
      const checkboxes = document.querySelectorAll(".consent-item .check-after-input");
      checkboxes.forEach((checkbox) => {
        checkbox.checked = this.values.consent;
      });
      this.consentItems.forEach((x) => (x.checked = this.values.consent));
      this.values.consents = [];
      this.consentItems.forEach((x) => this.values.consents.push(x));
    },
    setMasterToggle() {
      this.values.consents = [];
      this.consentItems.forEach((x) => this.values.consents.push(x));
    },
  },
  async mounted() {
    this.loadData();

    this.emitter.on("culture-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.product = this.store[this.store.currentCulture].values.productDetails
      this.d = this.store[this.store.currentCulture].dictionary;
      this.culture = this.store.currentCulture;

      // LOADS DATA ON LANGUAGE CHANGE
      this.loadData();
      this.v$.$reset();
    });
    this.emitter.on("union-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.renderDynamicCheckbox();
    });
    this.emitter.on("pay-by-company-change", () => {
      this.values = this.store[this.store.currentCulture].values.personalDetails;
      this.renderDynamicCheckbox();
    });
    this.emitter.on("insurance-change", () => {
      this.product = this.store[this.store.currentCulture].values.productDetails;
      this.renderDynamicCheckbox();
    });
    this.emitter.on("homeInsurance-change", () => {
      this.insurance = this.store[this.store.currentCulture].values.insuranceDetails;
      this.renderDynamicCheckbox();
    });
  },

  validations() {
    return {};
  },
};
</script>
<style scoped lang="postcss">
.headline-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.consent-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  margin-bottom: var(--grid-gutter);
  input {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
}

.consent-toggle-box {
  width: 67px;
  height: 30px;
  position: relative;
  background-color: #c4c4c4;
  border-radius: 15px;
  margin-right: 10px;
  transition: all 0.3s ease-in-out;
  &::before {
    transition: all 0.2s ease-in-out;
    content: "";
    width: 18px;
    height: 18px;
    border-radius: 18px;
    background-color: #fff;
    position: absolute;
    top: 6px;
    left: 7px;
  }
}

.consent-toggle {
  input:checked + .consent-toggle-box {
    background-color: #001965;
    &::before {
      left: 42px;
    }
  }
}

.consent-text {
  font-weight: 700;
}

.consent-item {
  margin-bottom: 40px;
  label {
    margin-bottom: 0;
  }
  .checklabel {
    font-weight: 700;
  }
  p {
    padding-left: 33px;
  }
}

.consent-item-checkbox {
  padding-left: 33px;
}

.consent-link {
  text-decoration: underline;
}

.custom-margin{
  padding-top: 50px;
}

.consent-rules-link{
  /* NOT SURE IF THIS IS COOL TO DO */
  margin-top: -15px;
}
</style>
